<script>
  import {onMount} from 'svelte'

  import {Link, navigate} from "svelte-routing";
  import Message from '../components/Message.svelte'

  import createMainProjectStore from '../stores/main-project'
  import Loader from '../components/Loader.svelte'

  let mainProject;

  function navigateToMainProject(project) {
    if (!project) return;

    navigate(`/project/${project.project_id}`, {replace: true});
  }

  onMount(async () => {
    mainProject = await createMainProjectStore();
  })

  $: navigateToMainProject($mainProject);

  $: loading = mainProject ? mainProject.loading : null;
</script>

<section class="nes-container is-dark is-rounded with-title">
  {#if $loading}
    <Loader text="Loading..." />
  {:else if !$mainProject}
    <section class="message-list">
      <Message>
        It looks like nothing is currently happening. Take a look in the
        <Link to="/projects">Archive</Link>
        to check out previous projects.
      </Message>
    </section>
  {/if}
</section>

<style>
    .nes-container {
        min-height: 10rem;
    }
</style>